"use client";

import Link from "next/link";
import { Headphones } from "lucide-react";

/** Imagery UX: unified link to TL V contact/support. */
export const LIEN_VEST_CONTACT_SUPPORT_PATH = "/contact-us";

export function ImagerySupportFab() {
	return (
		<Link
			href={LIEN_VEST_CONTACT_SUPPORT_PATH}
			className="fixed bottom-6 right-5 z-[40] flex h-14 w-14 touch-manipulation items-center justify-center rounded-full border border-white/10 bg-[#16251c] text-[#A7FF5E] shadow-[0_8px_30px_-8px_rgba(0,0,0,0.45)] ring-1 ring-black/10 transition-colors hover:bg-[#0f1b13] hover:ring-[#A7FF5E]/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#A7FF5E] focus-visible:ring-offset-2 sm:bottom-8 sm:right-8"
			aria-label="Contact Tax Lien Vest support"
			title="Contact support"
		>
			<Headphones
				className="h-6 w-6 shrink-0"
				aria-hidden
				strokeWidth={2}
			/>
		</Link>
	);
}

/** List + detail only (not onboarding route `/imagery/requests/new`). */
export function shouldShowImagerySupportFab(pathname: string): boolean {
	const n =
		pathname.length > 1 && pathname.endsWith("/")
			? pathname.slice(0, -1)
			: pathname;
	if (n === "/imagery/requests") return true;
	if (!n.startsWith("/imagery/requests/")) return false;
	const segment = n.slice("/imagery/requests/".length);
	if (!segment || segment.includes("/")) return false;
	return segment !== "new";
}
